<template>
    <v-container fluid tag="section">

        <div class="text-end">
            
        </div>

        <v-row>
            <v-col cols="12">
                <v-card class="rounded-lg mt-2">
                    <v-card-title>
                        <v-row class="py-2">
                            <v-col cols="12" md="9">
                                <v-btn outlined class="font-weight-bold me-2">
                                    {{ $t('Filter') }} <v-icon right>mdi-filter</v-icon>
                                </v-btn>
                                <v-btn outlined class="font-weight-bold me-2">
                                    {{ $t('Export') }} <v-icon right>mdi-file-table</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3" class="text-md-end">
                                <v-text-field hide-details flat filled outlined solo dense single-line
                                    append-icon="mdi-magnify" :label="$t('Search')" v-model="search"
                                    @keyup.enter="onSearch"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="px-0 py-0">
                        <v-data-table :items="items" :headers="headers" :options.sync="options"
                            :server-items-length="totalItems" :loading="loading" class="elevation-1">
                            <template v-slot:item="row">
                                <tr>
                                    <td>{{ row.item.id }}</td>
                                    <td>{{ row.item.currencyInfo.symbol }}{{ Number(row.item.amount).toFixed(2) }}</td>
                                    <td>
                                        <v-chip small :color="statusColor(row.item.status)" class="font-weight-bold">
                                            {{ $t(row.item.status.name) }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <router-link v-for="product in row.item.products" :to="`/plans/edit/${product.product_id}`" class="pr-2">
                                            {{ product.product.name }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link v-for="user in row.item.company?.users" :to="`/users/edit/${user.id}`" class="pr-2">
                                            {{ user.email }}
                                        </router-link>
                                    </td>
                                    <td>{{ row.item.created_at | utcToLocal }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import saleService from '@/services/saleService'

export default {
    data() {
        return {
            items: [],
            totalItems: 0,
            loading: true,
            options: { sortBy: ['id'], sortDesc: ['true'] },
            search: null,
            headers: [
                { text: '#', value: 'id' },
                { text: 'Amount', value: 'amount' },
                { text: 'Status', value: 'status_id' },
                { text: 'Products', sortable: false },
                { text: 'User', value: 'user_email' },
                { text: 'Created', value: 'created_at' },
            ],
            dialog: false,
            dialogItems: []
        }
    },
    watch: {
        options: {
            handler(curr, prev) {
                const watchProps = ['page', 'itemsPerPage', 'sortBy', 'sortDesc']
                for (let i = 0; i < watchProps.length; i++) {
                    const key = watchProps[i]
                    if (prev[key] !== curr[key]) {
                        return this.getSales()
                    }
                }
            },
            deep: true,
        },
    },
    methods: {
        async getSales() {
            this.loading = true
            try {
                const result = await saleService.paginate({
                    ...this.options,
                    search: this.search,
                    include_users: true,
                    include_products: true,
                })
                this.items = result.data.data
                this.totalItems = result.data.total
                this.options.page = result.data.page

            } catch (error) {
                this.$dialog.message.error(error.message)
            } finally {
                this.loading = false
            }
        },
        onSearch() {
            this.getSales()
        },
        statusColor(status) {
            const colors = {
                pending: '',
                completed: 'success',
                canceled: '',
                failed: 'error',
                refunded: 'warning',
            }
            return colors[status.alias]
        },
    },
}
</script>
